Date.prototype.toLocalISOString = function() {
  const tzo = this.getTimezoneOffset() * -1;
  const dif = tzo >= 0 ? '+' : '-';
  const pad = (n, width = 2) => {
    n = Math.floor(Math.abs(n)) + '';
    return n.length >= width
      ? n
      : new Array(width - n.length + 1).join('0') + n;
  };
  return (
    this.getFullYear() +
    '-' +
    pad(this.getMonth() + 1) +
    '-' +
    pad(this.getDate()) +
    'T' +
    pad(this.getHours()) +
    ':' +
    pad(this.getMinutes()) +
    ':' +
    pad(this.getSeconds()) +
    '.' +
    pad(this.getMilliseconds(), 3) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  );
};
